import OrchCustomData from './orch-custom-data';

/* returns an idToken from orchestartion object
* idToken needs to pass for enroll card
* condition if VISA recognized => send corresponding idToken else a random idToken
*/
const getIdToken = () => {
  return OrchCustomData.srcSdks?.apiResponseCache?.uniqueIdTokens ?? null;
};

export default getIdToken;
